<template>
    <!-- Large Device Layout (md and up) -->
    <v-card v-if="!xs" class="d-flex align-center" variant="flat">
        <v-card-text>
            <v-list-item class="flex-grow-1">
                <!-- Icon inside green (secondary) circular avatar -->
                <template #prepend>
                    <v-avatar size="36" color="secondary">
                        <v-icon class="white--text" size="20">
                            {{ forma.forma_clasificacion.icono }}
                        </v-icon>
                    </v-avatar>
                </template>

                <v-list-item-title
                    class="text-h5"
                    style="white-space: normal; word-break: break-word"
                >
                    {{ forma.nombre }}
                </v-list-item-title>

                <!-- Deadlines  -->
                <div
                    class="text-tertiary text-body-1 d-flex align-center"
                    style="white-space: normal; word-break: break-word"
                >
                    <span v-if="forma.fecha_precio_anticipado_formato != '0'">
                        {{ $t("home.formas.fecha-limite-descuento") }}
                        {{ forma.fecha_precio_anticipado_formato }}
                    </span>

                    <span v-else>
                        {{ $t("home.formas.fecha-cierre") }}
                        {{ $t("home.formas.fecha-cierre-dato") }}
                    </span>
                </div>

                <!-- Trailing section: Vendor Avatar + Need Help / Vendor Info + Cart Button -->
                <template #append>
                    <div class="d-flex align-center justify-end">
                        <!-- Vendor Info Menu -->
                        <v-menu
                            v-model="menuAbierto"
                            offset-y
                            max-width="400"
                            :close-on-content-click="false"
                        >
                            <template #activator="{ props }">
                                <div
                                    class="d-flex align-center cursor-pointer"
                                    v-bind="props"
                                >
                                    <v-avatar
                                        size="48"
                                        class="mr-2"
                                        variant="outlined"
                                        color="background"
                                    >
                                        <v-img
                                            :src="forma.usuario.url_logo"
                                            alt="Vendor Logo"
                                            width="40"
                                            height="40"
                                        ></v-img>
                                    </v-avatar>
                                    <div class="d-flex flex-column">
                                        <span class="text-caption grey--text">{{
                                            $t("necesita-ayuda")
                                        }}</span>
                                        <span
                                            class="text-caption text-secondary font-weight-medium"
                                            >{{ forma.usuario.nombre }}
                                            Info
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <v-card width="400">
                                <!-- Header -->
                                <v-card-title class="pb-2">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="text-h6 text--text text-uppercase"
                                            >{{ forma.usuario.nombre }}</span
                                        >
                                        <span
                                            class="text-body-2 text-textLight"
                                            >{{ $t("proveedor.titulo") }}</span
                                        >
                                    </div>
                                </v-card-title>

                                <v-divider></v-divider>

                                <!-- Tabs -->
                                <v-tabs
                                    v-model="activeTab"
                                    grow
                                    color="secondary"
                                >
                                    <v-tab value="contact">{{
                                        $t("contacto")
                                    }}</v-tab>
                                    <v-tab value="bank">{{
                                        $t("desposito-transferencia")
                                    }}</v-tab>
                                </v-tabs>

                                <v-card-text style="background-color: #f5f7f8">
                                    <v-window v-model="activeTab">
                                        <!-- Contact Tab -->
                                        <v-window-item value="contact">
                                            <v-list bg-color="background">
                                                <!-- Contact Name -->
                                                <v-list-item
                                                    :subtitle="
                                                        $t('contacto-nombre')
                                                    "
                                                    :title="
                                                        forma.usuario
                                                            .contacto_nombre
                                                    "
                                                >
                                                    <template v-slot:prepend>
                                                        <v-btn
                                                            color="secondary"
                                                            icon="mdi-account-outline"
                                                            variant="text"
                                                        ></v-btn>
                                                    </template>
                                                </v-list-item>

                                                <!-- Phone -->
                                                <v-list-item
                                                    v-if="
                                                        forma.usuario
                                                            .contacto_telefono
                                                    "
                                                    :subtitle="
                                                        $t('contacto-telefono')
                                                    "
                                                    :title="
                                                        forma.usuario
                                                            .contacto_telefono
                                                    "
                                                >
                                                    <template v-slot:prepend>
                                                        <v-btn
                                                            color="secondary"
                                                            icon="mdi-phone-hangup-outline"
                                                            variant="text"
                                                        ></v-btn>
                                                    </template>
                                                </v-list-item>

                                                <!-- Email -->
                                                <v-list-item
                                                    v-if="
                                                        forma.usuario
                                                            .contacto_correo
                                                    "
                                                    :subtitle="
                                                        $t('contacto-correo')
                                                    "
                                                    :title="
                                                        forma.usuario
                                                            .contacto_correo
                                                    "
                                                >
                                                    <template v-slot:prepend>
                                                        <v-btn
                                                            color="secondary"
                                                            icon="mdi-email-outline"
                                                            variant="text"
                                                        ></v-btn>
                                                    </template>
                                                    <template v-slot:append>
                                                        <v-btn
                                                            color="textLight"
                                                            :icon="
                                                                copiadoTexto[
                                                                    forma
                                                                        .usuario
                                                                        .contacto_correo
                                                                ]
                                                                    ? 'mdi-check'
                                                                    : 'mdi-content-copy'
                                                            "
                                                            variant="text"
                                                            @click="
                                                                copiarTexto(
                                                                    forma
                                                                        .usuario
                                                                        .contacto_correo
                                                                )
                                                            "
                                                        ></v-btn>
                                                    </template>
                                                </v-list-item>
                                            </v-list>
                                        </v-window-item>

                                        <!-- Bank Tab -->
                                        <v-window-item value="bank">
                                            <v-list bg-color="background">
                                                <!-- Bank Account Pesos Section -->
                                                <v-list-subheader
                                                    class="text-uppercase font-weight-bold text-secondary"
                                                >
                                                    {{
                                                        $t(
                                                            "cuenta-bancaria-pesos"
                                                        )
                                                    }}
                                                </v-list-subheader>

                                                <v-list-item
                                                    v-if="
                                                        forma.usuario
                                                            .usuario_bancos
                                                            .length == 0
                                                    "
                                                    :subtitle="$t('no-datos')"
                                                ></v-list-item>

                                                <v-list-item
                                                    v-for="banco in forma
                                                        .usuario.usuario_bancos"
                                                    :key="banco.id"
                                                    :subtitle="banco.etiqueta"
                                                    :title="banco.valor"
                                                    v-else
                                                >
                                                    <template v-slot:append>
                                                        <v-btn
                                                            color="textLight"
                                                            :icon="
                                                                copiadoTexto[
                                                                    banco.valor
                                                                ]
                                                                    ? 'mdi-check'
                                                                    : 'mdi-content-copy'
                                                            "
                                                            variant="text"
                                                            @click="
                                                                copiarTexto(
                                                                    banco.valor
                                                                )
                                                            "
                                                        ></v-btn>
                                                    </template>
                                                </v-list-item>

                                                <v-divider
                                                    class="my-3"
                                                ></v-divider>

                                                <!-- Bank Account USD Section -->
                                                <v-list-subheader
                                                    class="text-uppercase font-weight-bold text-secondary"
                                                >
                                                    {{
                                                        $t(
                                                            "cuenta-bancaria-dolares"
                                                        )
                                                    }}
                                                </v-list-subheader>

                                                <v-list-item
                                                    v-if="
                                                        forma.usuario
                                                            .usuario_bancos2
                                                            .length == 0
                                                    "
                                                    :subtitle="$t('no-datos')"
                                                ></v-list-item>

                                                <v-list-item
                                                    v-for="banco in forma
                                                        .usuario
                                                        .usuario_bancos2"
                                                    :key="banco.id"
                                                    :subtitle="banco.etiqueta"
                                                    :title="banco.valor"
                                                    v-else
                                                >
                                                    <template v-slot:append>
                                                        <v-btn
                                                            color="textLight"
                                                            :icon="
                                                                copiadoTexto[
                                                                    banco.valor
                                                                ]
                                                                    ? 'mdi-check'
                                                                    : 'mdi-content-copy'
                                                            "
                                                            variant="text"
                                                            @click="
                                                                copiarTexto(
                                                                    banco.valor
                                                                )
                                                            "
                                                        ></v-btn>
                                                    </template>
                                                </v-list-item>
                                            </v-list>
                                        </v-window-item>
                                    </v-window>
                                </v-card-text>
                                <v-card-actions
                                    class="d-flex flex-row justify-center"
                                >
                                    <v-btn
                                        variant="outlined"
                                        color="secondary"
                                        @click="menuAbierto = false"
                                    >
                                        {{ $t("boton-cerrar") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>

                        <!-- Shopping Cart Button with Badge -->
                        <v-badge
                            v-if="estatus == 1 && tipo == 'a' && mostrarBadge"
                            bordered
                            color="error"
                            :content="cantidadBadge"
                            overlap
                            class="pa-3"
                        >
                            <v-btn
                                icon
                                variant="outlined"
                                color="secondary"
                                size="40px"
                                class="shopping-cart-button"
                                :href="
                                    route(
                                        'forma-dinamica-' +
                                            (tipo ? tipo : 'a') +
                                            '.carrito',
                                        {
                                            stand: stand.id,
                                            forma: forma.parametros,
                                        }
                                    )
                                "
                            >
                                <v-icon size="24px" color="secondary"
                                    >mdi-cart-outline</v-icon
                                >
                            </v-btn>
                        </v-badge>

                        <!-- Cart button without badge when empty -->
                        <v-btn
                            v-if="estatus == 1 && tipo == 'a' && !mostrarBadge"
                            icon
                            variant="outlined"
                            color="secondary"
                            size="40px"
                            class="shopping-cart-button"
                            :href="
                                route(
                                    'forma-dinamica-' +
                                        (tipo ? tipo : 'a') +
                                        '.carrito',
                                    {
                                        stand: stand.id,
                                        forma: forma.parametros,
                                    }
                                )
                            "
                        >
                            <v-icon size="24px" color="secondary"
                                >mdi-cart-outline</v-icon
                            >
                        </v-btn>
                    </div>
                </template>
            </v-list-item>
        </v-card-text>
    </v-card>

    <!-- Extra Small Device Layout (xs only) -->
    <v-card
        v-else
        class="my-4 d-flex flex-column justify-center align-center"
        variant="flat"
    >
        <v-card-text>
            <!-- Title -->
            <div class="d-flex justify-center mb-3">
                <span class="text-h5 text-center" style="line-height: 1.2">
                    {{ forma.nombre }}
                </span>
            </div>

            <!-- Deadlines -->
            <div class="d-flex justify-center mb-3">
                <!-- Deadlines for types 'a' and 'b' -->
                <div
                    v-if="
                        (tipo == 'a' || tipo == 'b') && forma.fecha_baja_formato
                    "
                    class="text-body-2 text-tertiary text-center d-flex align-center flex-wrap justify-center"
                >
                    <span v-if="forma.fecha_precio_anticipado_formato != '0'">
                        {{ $t("home.formas.fecha-limite-descuento") }}
                        {{ forma.fecha_precio_anticipado_formato }}
                    </span>
                    <!--   <span
                        v-if="forma.fecha_precio_anticipado_formato != '0'"
                        class="mx-2 text-tertiary"
                        style="border-left: 2px solid; height: 16px"
                    ></span>
                    <span>
                        {{ $t("home.formas.fecha-cierre") }}
                        {{ forma.fecha_baja_formato }}
                    </span>-->
                </div>

                <!-- Deadline for type 'c' -->
                <span
                    v-if="tipo == 'c' && forma.fecha_baja_formato"
                    class="text-body-2 text-tertiary text-center"
                >
                    {{ $t("home.formas.fecha-cierre") }}
                    {{ forma.fecha_baja_formato }}
                </span>
            </div>
            <!-- Contact Us and Cart Button -->
            <div class="d-flex justify-center align-center">
                <!-- Vendor Info Menu -->
                <v-menu
                    v-model="menuAbiertoXs"
                    offset-y
                    max-width="400"
                    :close-on-content-click="false"
                >
                    <template #activator="{ props }">
                        <div
                            class="d-flex align-center cursor-pointer"
                            v-bind="props"
                        >
                            <v-avatar
                                size="48"
                                class="mr-2"
                                variant="outlined"
                                color="background"
                            >
                                <v-img
                                    :src="forma.usuario.url_logo"
                                    alt="Vendor Logo"
                                    width="40"
                                    height="40"
                                ></v-img>
                            </v-avatar>
                            <div class="d-flex flex-column">
                                <span class="text-caption grey--text">{{
                                    $t("necesita-ayuda")
                                }}</span>
                                <span
                                    class="text-caption text-secondary font-weight-medium"
                                >
                                    {{ forma.usuario.nombre }} Info
                                </span>
                            </div>
                        </div>
                    </template>

                    <v-card width="320">
                        <!-- Header -->
                        <v-card-title class="pb-2">
                            <div class="d-flex flex-column">
                                <span
                                    class="text-h6 text--text text-uppercase"
                                    >{{ forma.usuario.nombre }}</span
                                >
                                <span class="text-body-2 text-textLight">{{
                                    $t("proveedor.titulo")
                                }}</span>
                            </div>
                        </v-card-title>

                        <v-divider></v-divider>

                        <!-- Tabs -->
                        <v-tabs v-model="activeTab" grow color="secondary">
                            <v-tab value="contact">{{ $t("contacto") }}</v-tab>
                            <v-tab value="bank">{{
                                $t("desposito-transferencia")
                            }}</v-tab>
                        </v-tabs>

                        <v-card-text style="background-color: #f5f7f8">
                            <v-window v-model="activeTab">
                                <!-- Contact Tab -->
                                <v-window-item value="contact">
                                    <v-list bg-color="background">
                                        <!-- Contact Name -->
                                        <v-list-item
                                            :subtitle="$t('contacto-nombre')"
                                            :title="
                                                forma.usuario.contacto_nombre
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-account-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                        </v-list-item>

                                        <!-- Phone -->
                                        <v-list-item
                                            v-if="
                                                forma.usuario.contacto_telefono
                                            "
                                            :subtitle="$t('contacto-telefono')"
                                            :title="
                                                forma.usuario.contacto_telefono
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-phone-hangup-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                        </v-list-item>

                                        <!-- Email -->
                                        <v-list-item
                                            v-if="forma.usuario.contacto_correo"
                                            :subtitle="$t('contacto-correo')"
                                            :title="
                                                forma.usuario.contacto_correo
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-email-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                            <template v-slot:append>
                                                <v-btn
                                                    color="textLight"
                                                    :icon="
                                                        copiadoTexto[
                                                            forma.usuario
                                                                .contacto_correo
                                                        ]
                                                            ? 'mdi-check'
                                                            : 'mdi-content-copy'
                                                    "
                                                    variant="text"
                                                    @click="
                                                        copiarTexto(
                                                            forma.usuario
                                                                .contacto_correo
                                                        )
                                                    "
                                                ></v-btn>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-window-item>

                                <!-- Bank Tab -->
                                <v-window-item value="bank">
                                    <v-list bg-color="background">
                                        <!-- Bank Account Pesos Section -->
                                        <v-list-subheader
                                            class="text-uppercase font-weight-bold text-secondary"
                                        >
                                            {{ $t("cuenta-bancaria-pesos") }}
                                        </v-list-subheader>

                                        <v-list-item
                                            v-for="banco in forma.usuario
                                                .usuario_bancos"
                                            :key="banco.id"
                                            :subtitle="banco.etiqueta"
                                            :title="banco.valor"
                                        >
                                            <template v-slot:append>
                                                <v-btn
                                                    color="textLight"
                                                    :icon="
                                                        copiadoTexto[
                                                            banco.valor
                                                        ]
                                                            ? 'mdi-check'
                                                            : 'mdi-content-copy'
                                                    "
                                                    variant="text"
                                                    @click="
                                                        copiarTexto(banco.valor)
                                                    "
                                                ></v-btn>
                                            </template>
                                        </v-list-item>

                                        <v-divider class="my-3"></v-divider>

                                        <!-- Bank Account USD Section -->
                                        <v-list-subheader
                                            class="text-uppercase font-weight-bold text-secondary"
                                        >
                                            {{ $t("cuenta-bancaria-dolares") }}
                                        </v-list-subheader>

                                        <v-list-item
                                            v-for="banco in forma.usuario
                                                .usuario_bancos2"
                                            :key="banco.id"
                                            :subtitle="banco.etiqueta"
                                            :title="banco.valor"
                                        >
                                            <template v-slot:append>
                                                <v-btn
                                                    color="textLight"
                                                    :icon="
                                                        copiadoTexto[
                                                            banco.valor
                                                        ]
                                                            ? 'mdi-check'
                                                            : 'mdi-content-copy'
                                                    "
                                                    variant="text"
                                                    @click="
                                                        copiarTexto(banco.valor)
                                                    "
                                                ></v-btn>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-window-item>
                            </v-window>
                        </v-card-text>
                        <v-card-actions class="d-flex flex-row justify-center">
                            <v-btn
                                variant="outlined"
                                color="secondary"
                                @click="menuAbiertoXs = false"
                            >
                                {{ $t("boton-cerrar") }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>

                <!-- Shopping Cart Button with Badge -->
                <v-badge
                    v-if="estatus == 1 && tipo == 'a' && mostrarBadge"
                    bordered
                    color="error"
                    :content="cantidadBadge"
                    overlap
                    class="pa-3 ml-2"
                >
                    <v-btn
                        icon
                        variant="outlined"
                        color="secondary"
                        size="40px"
                        class="shopping-cart-button"
                        :href="
                            route(
                                'forma-dinamica-' +
                                    (tipo ? tipo : 'a') +
                                    '.carrito',
                                {
                                    stand: stand.id,
                                    forma: forma.parametros,
                                }
                            )
                        "
                    >
                        <v-icon size="24px" color="secondary"
                            >mdi-cart-outline</v-icon
                        >
                    </v-btn>
                </v-badge>

                <!-- Cart button without badge when empty -->
                <v-btn
                    v-if="estatus == 1 && tipo == 'a' && !mostrarBadge"
                    icon
                    variant="outlined"
                    color="secondary"
                    size="40px"
                    class="shopping-cart-button"
                    :href="
                        route(
                            'forma-dinamica-' +
                                (tipo ? tipo : 'a') +
                                '.carrito',
                            {
                                stand: stand.id,
                                forma: forma.parametros,
                            }
                        )
                    "
                >
                    <v-icon size="24px" color="secondary"
                        >mdi-cart-outline</v-icon
                    >
                </v-btn>
            </div>
        </v-card-text>
    </v-card>

    <!-- Overlay cuando el menú está abierto - cubre toda la pantalla -->
    <v-overlay
        v-model="menuAbierto"
        scrim="black"
        persistent
        style="z-index: 1999"
    >
    </v-overlay>
    <v-overlay
        v-model="menuAbiertoXs"
        scrim="black"
        persistent
        style="z-index: 1999"
    >
    </v-overlay>
</template>

<script setup>
import axios from "axios";
import { ref, onMounted } from "vue";
import { useDisplay } from "vuetify";

const props = defineProps({
    forma: Object,
    stand: Object,
    estatus: Number,
    tipo: String,
});

const { xs } = useDisplay();

const cantidadBadge = ref(0);
const mostrarBadge = ref(false);
const activeTab = ref("contact");
const copiadoTexto = ref({});
const menuAbierto = ref(false);
const menuAbiertoXs = ref(false);

const copiarTexto = async (texto) => {
    try {
        await navigator.clipboard.writeText(texto);
        copiadoTexto.value[texto] = true;
        setTimeout(() => {
            copiadoTexto.value[texto] = false;
        }, 2000);
    } catch (err) {
        console.error("Error al copiar:", err);
    }
};

onMounted(() => {
    axios
        .get(
            route("forma-dinamica-a.conteo", {
                stand: props.stand.id,
                forma: props.forma.parametros,
            })
        )
        .then((response) => {
            if (response.data == 0) {
                cantidadBadge.value = null;
                mostrarBadge.value = false;
            }
            if (response.data > 0) {
                cantidadBadge.value = response.data;
                mostrarBadge.value = true;
            }
        });
});
</script>

<style scoped>
.v-card {
    background-color: rgb(var(--v-theme-white));
}

.cursor-pointer {
    cursor: pointer;
}

.v-tab--selected .tab-text {
    color: rgb(var(--v-theme-secondary));
}

.bank-row {
    gap: 16px;
    padding-left: 11px;
}

.bank-label {
    flex: 0 0 72px;
    width: 72px;
    text-align: left;
}

.bank-value {
    flex: 1;
    text-align: left;
}

.shopping-cart-button {
    border-width: 2px;
    margin-left: 24px;
}
</style>
